import { ComponentType } from 'react';
import dynamic from 'next/dynamic';
import { ScreenType } from 'core/flow/entities';

interface ScreenComponentDefinition {
  Screen: ComponentType<{ screenId: string }>;
  importChunk: () => Promise<unknown>;
}

// TODO: remove after

// @ts-expect-error - TODO rm it
export const screenComponents: Record<QuizStepTypes | ScreenType, ScreenComponentDefinition> = {
  [ScreenType.NEB_ANSWER]: {
    Screen: dynamic(() => import('./Answer').then((module) => module.AnswerStep)),
    importChunk: () => import('./Answer'),
  },
  [ScreenType.NEB_ANSWER_RATING]: {
    Screen: dynamic(() => import('./AnswerRating').then((module) => module.AnswerRatingStep)),
    importChunk: () => import('./AnswerRating'),
  },

  [ScreenType.NEB_MULTIPLE_ANSWERS]: {
    Screen: dynamic(() => import('./MultipleAnswers').then((module) => module.MultipleAnswersStep)),
    importChunk: () => import('./MultipleAnswers'),
  },
  [ScreenType.NEB_SPLIT]: {
    Screen: dynamic(() => import('./Split').then((module) => module.Split)),
    importChunk: () => import('./Split'),
  },
  [ScreenType.NEB_ONBOARDING]: {
    Screen: dynamic(() => import('./Onboarding').then((module) => module.OnboardingStep)),
    importChunk: () => import('./Onboarding'),
  },
  [ScreenType.NEB_ASK_ONBOARDING]: {
    Screen: dynamic(() => import('./AskOnboarding').then((module) => module.AskOnboardingStep)),
    importChunk: () => import('./AskOnboarding'),
  },
  [ScreenType.NEB_DATE]: {
    Screen: dynamic(() => import('./Date').then((module) => module.DateStep)),
    importChunk: () => import('./Date'),
  },
  [ScreenType.NEB_LOADER_WITH_CONTENT]: {
    Screen: dynamic(() =>
      import('./LoaderWithContent').then((module) => module.LoaderWithContentStep),
    ),
    importChunk: () => import('./LoaderWithContent'),
  },
  [ScreenType.NEB_SCAN]: {
    Screen: dynamic(() => import('./Scan').then((module) => module.ScanStep)),
    importChunk: () => import('./Scan'),
  },
  [ScreenType.NEB_TRIAL_PAYMENT]: {
    Screen: dynamic(() => import('./TrialPayment').then((module) => module.TrialPaymentStep)),
    importChunk: () => import('./TrialPayment'),
  },
  [ScreenType.NEB_EMAIL_CONFIRM]: {
    Screen: dynamic(() => import('./EmailConfirm').then((module) => module.EmailConfirmStep)),
    importChunk: () => import('./EmailConfirm'),
  },
  [ScreenType.NEB_UPSELLS]: {
    Screen: dynamic(() => import('./Upsells').then((module) => module.UpsellsStep)),
    importChunk: () => import('./Upsells'),
  },
  [ScreenType.NEB_PHONE_NUMBER]: {
    Screen: dynamic(() => import('./PhoneNumber').then((module) => module.PhoneNumberStep)),
    importChunk: () => import('./PhoneNumber'),
  },
  [ScreenType.NEB_W2A_PROMOTION]: {
    Screen: dynamic(() => import('./W2APromotion').then((module) => module.W2APromotionStep)),
    importChunk: () => import('./W2APromotion'),
  },
  [ScreenType.NEB_EMAIL]: {
    Screen: dynamic(() => import('./Email').then((module) => module.EmailStep)),
    importChunk: () => import('./Email'),
  },
  [ScreenType.NEB_INFORMATIONAL_DYNAMIC]: {
    Screen: dynamic(() =>
      import('./InformationalDynamic').then((module) => module.InformationalDynamicStep),
    ),
    importChunk: () => import('./InformationalDynamic'),
  },
  [ScreenType.NEB_INITIAL]: {
    Screen: dynamic(() => import('./Initial').then((module) => module.InitialStep)),
    importChunk: () => import('./Initial'),
  },
};
